// Thin fetch layer for talking to our FastAPI backend, which itself
// proxies Shopify Storefront GraphQL. Keeps the frontend clean of URLs.

import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchProducts = async (collection) => {
  const { data } = await axios.get(`${API}/products`, {
    params: collection ? { collection } : {},
  });
  return data.products || [];
};

export const fetchProduct = async (handle) => {
  const { data } = await axios.get(`${API}/products/${handle}`);
  return data;
};

export const fetchCollections = async () => {
  const { data } = await axios.get(`${API}/collections`);
  return data.collections || [];
};

export const fetchCollection = async (handle) => {
  const { data } = await axios.get(`${API}/collections/${handle}`);
  return data;
};

export const createShopifyCart = async (lines) => {
  const { data } = await axios.post(`${API}/cart`, { lines });
  return data;
};
